module.exports = __webpack_public_path__ + "img/3-424-424.cefd2ee0.png";